import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2021_425)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M24 23.3C22.2 19.2 18.9 16.4 15.1 15.4C18 14.2 20.1 11.3 20.1 8C20.1 3.6 16.5 0 12.1 0C7.7 0 4 3.6 4 8C4 11.3 6 14.2 9 15.4C5.2 16.4 1.9 19.2 0.1 23.3C0 23.6 0.1 23.8 0.4 24C0.7 24.1 0.9 24 1.1 23.7C3.1 19 7.3 16 12 16C16.7 16 20.9 19 23 23.7C23.1 23.9 23.3 24 23.5 24C23.6 24 23.6 24 23.7 24C24 23.8 24.1 23.5 24 23.3ZM5 8C5 4.1 8.1 1 12 1C15.9 1 19 4.1 19 8C19 11.9 15.9 15 12 15C8.1 15 5 11.9 5 8Z",
			fill: "#F5F4F3"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2021_425",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgProfile;
